import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Divider from 'components/common/divider';
import AssessmentName from 'components/assessments/assessment-name';
import AssessmentPoint from 'components/assessments/assessment-point';
import AssessmentCriteria from 'components/assessments/assessment-criteria';
import { destandard } from 'utils/commonFunctions';

class Assessment extends Component {
  render () {
    const { assessment } = this.props;
    const {
      name,
      link,
      points_rewarded,
      criteria
    } = destandard({ ...assessment.attributes });

    return (
      <Grid className="assessment-criteria-container">
        <div className="assessment-criteria-divider">
          <Divider />
        </div>
        <Row className="assessment-criteria-row">
          <Col>
            <AssessmentName
              name={name}
              image={link.image}
            />
          </Col>
          <Col>
            <AssessmentPoint
              pointsRewarded={points_rewarded}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <AssessmentCriteria criteria={criteria} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Assessment;



// WEBPACK FOOTER //
// ./src/components/assessments/assessment.jsx